import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SwapButton from './swapbutton/SwapButton';
import TokenAuthSection from './connector/TokenAuthSection';
import SwapPage from './swapconfig/SwapPage';
import { GlobalStateProvider } from './GlobalStateContext';
import RainbowProvider from './connector/RainbowProvider';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { GuideButton } from './guide';
import GasDisplay from './gasDisplay/GasDisplay';
import OpenSourceLabel from './openSourceLabel';

// 新拟态设计系统样式导入
import './css/global-reset.css';
import './css/neumorphism-theme.css';
import './css/App.css';

// 主页组件
function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <div style={{display:'flex',alignItems:'left',justifyContent:'start'}}>
              <ConnectButton />
              <GuideButton />
              <OpenSourceLabel />
              <GasDisplay />
              <span style={{ 
                flex: 1, 
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>刷分合约已开源, 其余逻辑完全在浏览器中执行, 0后端数据传输,安全可靠,盈亏自负</span>
        </div>
       
      </header>
      
      <main className="App-main">
        <div className="two-column-layout">
          <div className="left-column">
              <TokenAuthSection />
            <div className="left-bottom-section">
              <SwapPage />
            </div>
          </div>
          <div className="right-column">
            <SwapButton />
          </div>
        </div>
      </main>
      
   
    </div>
  );
}

// Liquid 页面组件 - 只渲染 SwapPage
function LiquidPage() {
  return (
    <div className="App">
      <main className="App-main">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'flex-start',
          padding: '20px'
        }}>
          <SwapPage />
        </div>
      </main>
    </div>
  );
}

function App() {
  console.log('App重新渲染!!')
  return (
    <RainbowProvider>
      <GlobalStateProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/liquid" element={<LiquidPage />} />
          </Routes>
        </Router>
      </GlobalStateProvider>
    </RainbowProvider>
  );
}

export default App; 